// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2grby","emails":"CreateEditClinics_emails__1C2r9","emailTagLabel":"CreateEditClinics_emailTagLabel__1vi2M"};